import styled from '@emotion/styled';

import { authColors, authLayout } from 'design-system/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${authColors.white};
`;

export type ContentVariant = 'login' | 'onboarding';

export const Content = styled.main<{ variant?: ContentVariant }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  padding: 40px 32px;

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    align-items: flex-start;
    background: ${({ variant }) =>
      variant === 'onboarding' ? authColors.surface : authColors.white};
    padding: ${({ variant }) =>
      variant === 'onboarding' ? '24px 16px 32px' : '16px 24px 32px'};
  }
`;
